/**
 * SuperAdmin Error Logs Endpoints
 * Critical Error Logging System - Admin Panel APIs
 */

export const ERROR_LOGS_ENDPOINTS = {
  // Statistics
  statistics: 'critical-error-log/statistics',
  
  // List & View
  list: 'critical-error-log/list',
  view: 'critical-error-log/view',
  occurrences: 'critical-error-log/occurrences',
  
  // Actions
  resolve: 'critical-error-log/resolve',
  reopen: 'critical-error-log/reopen',
  
  // Notification Config
  notificationConfig: 'critical-error-log/notification-config',
};
